import { render } from "./gestionNoticiaCard.vue?vue&type=template&id=68300878&scoped=true"
import script from "./gestionNoticiaCard.vue?vue&type=script&lang=js"
export * from "./gestionNoticiaCard.vue?vue&type=script&lang=js"

import "./gestionNoticiaCard.vue?vue&type=style&index=0&id=68300878&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68300878"]])

export default __exports__